module.exports = __webpack_public_path__ + "static/media/latitude2x-m.f5167c85.jpg";